import { render } from "./PageLoader.vue?vue&type=template&id=0d5cebb0&scoped=true"
const script = {}

import "./PageLoader.vue?vue&type=style&index=0&id=0d5cebb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5cebb0"]])

export default __exports__